import React, { createContext, useContext, useReducer } from 'react';

const SearchResultsContext = createContext();

const initialState = {
  results: null,
  loading: false,
  error: null,
  searchParams: null
};

function searchResultsReducer(state, action) {
  console.log('SearchResults Reducer:', { 
    type: action.type, 
    payload: action.payload,
    currentState: state 
  });

  switch (action.type) {
    case 'SET_LOADING':
      return {
        ...state,
        loading: true,
        error: null
      };
    case 'SET_RESULTS':
      return {
        ...state,
        loading: false,
        results: action.payload,
        error: null
      };
    case 'SET_ERROR':
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}

export function SearchResultsProvider({ children }) {
  const [state, dispatch] = useReducer(searchResultsReducer, initialState);

  return (
    <SearchResultsContext.Provider value={{ state, dispatch }}>
      {children}
    </SearchResultsContext.Provider>
  );
}

export function useSearchResults() {
  const context = useContext(SearchResultsContext);
  if (!context) {
    throw new Error('useSearchResults must be used within a SearchResultsProvider');
  }
  return context;
} 